<template>
  <div class="type-panel p-6">
    <img :src="trip.tripSummary.photoUrl" class="summary-cover-photo" />

    <div
      v-if="trip.tripSummary.status == 'active' && startsInDays"
      class="has-text-grey mb-2 is-size-7"
    >
      {{ startsInDays }}
    </div>

    <h3 class="is-size-6  has-text-weight-light">
      <span>{{ trip.startDate | formatDate }} </span>
      <span v-if="trip.startDate != trip.endDate"
        >- {{ trip.endDate | formatDate }}</span
      >
    </h3>

    <div class="calendar-container is-size-7" v-if="isEditable">
      <a @click="generateCalendar">Add to calendar</a>
    </div>

    <h2 class="is-size-4">{{ tripName }}</h2>

    <div class="trip-description-container" v-if="trip.tripDescription">
      Trip Description: {{ trip.tripDescription }}
    </div>

    <div class="is-size-6">
      Reference number:
      <span class="has-text-weight-bold ">
        {{ trip.recordLocator }}
      </span>
    </div>

    <h4 class="is-size-6 mt-3 has-text-grey">Traveler(s):</h4>

    <div
      class="passenger"
      v-for="(passenger, index) in trip.passengers"
      :key="index"
    >
      {{ passenger.firstName }} {{ passenger.lastName }}
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { saveAs } from "file-saver";
export default {
  name: "TripSummary",
  components: {},
  props: {
    trip: {
      required: true,
      type: Object,
    },
    isEditable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {};
  },
  computed: {
    //TO DO: Return "Your previous trip" if past end date
    startsInDays() {
      if (this.trip.tripSummary?.daysUntilStart == 0) {
        return "Starts today";
      } else if (this.trip.tripSummary?.daysUntilStart > 0) {
        return "Starts in " + this.trip.tripSummary.daysUntilStart + " days";
      } else if (this.trip.tripSummary?.daysUntilStart < 0) {
        return "Your current trip";
      }
      return null;
    },
    tripName(){
      if (this.trip.tripSummary.tripName){
        return this.trip.tripSummary.tripName;
      } else {
        return this.trip.tripSummary.cityState;
      }
    },
  },
  methods: {
    generateCalendar() {
      // console.log(this.trip.calendar)
      let filename =
        "TripCircuit-Reservation-" + this.trip.recordLocator + ".ics";
      var blob = new Blob([this.trip.calendar], {
        type: "text/x-vCalendar;charset=utf-8",
      });
      saveAs(blob, filename);
    },
  },
};
</script>

<style>
.summary-cover-photo {
  height: 170px;
  object-fit: cover;
  border-radius: 5px;
  width: 100%;
}
</style>
